import React, { useEffect, useState } from "react";
import {
  FaHeart,
  FaUsers,
  FaRupeeSign,
  FaHistory,
  FaStar
} from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { RxDotFilled } from "react-icons/rx";
import { PiSlidersHorizontalBold } from "react-icons/pi";
import { IoClose } from "react-icons/io5"; // for cross icon

import "./FilterBar.css";

const iconMap = {
  PiSlidersHorizontalBold,
  FaHeart,
  FaUsers,
  FaRupeeSign,
  FaHistory,
  FaStar,
  IoIosArrowDown,
  RxDotFilled
};

const FilterBar = ({ filterList,setFiltersAndSort, setShowFilter }) => {
  const [selectedPills, setSelectedPills] = useState([]);
  const [selectedDropdowns, setSelectedDropdowns] = useState({});

  const handlePillClick = (label) => {
    setSelectedPills((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label]
    );
  };

  const handleRemovePill = (label) => {
    setSelectedPills((prev) => prev.filter((item) => item !== label));
  };

  const handleDropdownChange = (label, value) => {
    setSelectedDropdowns((prev) => ({
      ...prev,
      [label]: value
    }));
  };

  const handleRemoveDropdown = (label) => {
    setSelectedDropdowns((prev) => {
      const updated = { ...prev };
      delete updated[label];
      return updated;
    });
  };

  useEffect(() => {
    setFiltersAndSort({ selectedPills, selectedDropdowns });
  }, [selectedPills, selectedDropdowns]);


  return (
    <div className="filter-container">
      {filterList.map((filter, index) => {
        const Icon = iconMap[filter.icon];

        // 1. Dropdown
        if (filter.type === "dropdown") {
          const isSelected = selectedDropdowns[filter.label];
          return (
            <div key={index} className="filter-dropdown-wrapper">
              <div className={`filter-dropdown-display ${isSelected ? "active" : ""}`}>
                <select
                  className="filter-dropdown"
                  value={selectedDropdowns[filter.label] || ""}
                  onChange={(e) => handleDropdownChange(filter.label, e.target.value)}
                >
                  <option value="" disabled hidden selected>
                    {filter.label}
                  </option>
                  {filter.options &&
                    filter.options.map((opt, i) => (
                      <option key={i} value={opt}>
                        {opt}
                      </option>
                    ))}
                </select>
                {isSelected && (
                  <span className="clear-icon" onClick={() => handleRemoveDropdown(filter.label)}>
                    <IoClose />
                  </span>
                )}
              </div>
            </div>
          );
        }

        // 2. Pill
        if (filter.type === "pill") {
          const isActive = selectedPills.includes(filter.label);
          return (
            <button
              key={index}
              className={`filter-pill ${isActive ? "active" : ""}`}
              onClick={() => handlePillClick(filter.label)}
            >
              {Icon && <Icon style={{ marginRight: 6 }} />}
              {filter.label}
              {isActive && (
                <span
                  className="clear-icon"
                  onClick={(e) => {
                    e.stopPropagation(); // prevent re-triggering selection
                    handleRemovePill(filter.label);
                  }}
                >
                  <IoClose />
                </span>
              )}
            </button>
          );
        }

        // 3. Default Button
        return (
          <button
            key={index}
            className="filter-btn-bar"
            onClick={() => {
              setShowFilter(true);
            }}
          >
            {Icon && <Icon style={{ marginRight: 6 }} />}
            {filter.label}
          </button>
        );
      })}
    </div>
  );
};

export default FilterBar;
